import { IconButton } from "$components/button/icon-button";
import { Box, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useIntl } from "react-intl";
import type { InsurerDetailsActionsProps } from "./types";

export const InsurerDetailsActions = ({
  deleteInsurer,
}: InsurerDetailsActionsProps) => {
  const { formatMessage } = useIntl();
  return (
    <Grid container justifyContent="flex-end" alignItems="center">
      <Grid item xs={12}>
        <Box textAlign="right" pb={2}>
          <IconButton
            onClick={deleteInsurer}
            color="error"
            aria-label={formatMessage({
              id: "insurerDetails.actions.delete",
              defaultMessage: "Delete Insurer",
            })}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  );
};
